window.addEventListener("load", () => {
    (function() {
        const scriptSrc = "https://d3p29gcwgas9m8.cloudfront.net/assets/js/index.js";
        const urlParams = new URLSearchParams(window.location.search);
        const hasVariant = urlParams.has('variant');

        if (!hasVariant) {
            const selectElement = document.querySelector('.module-wrap select');

            if (selectElement) {
                const event = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(event);

                setTimeout(() => {
                    reinitializeScriptWithJQuery(scriptSrc);
                }, 250);
            }
        }

        const selectElementsList = document.querySelectorAll('.module-wrap select').forEach(select => {
            select.addEventListener("change", () => {
                setTimeout(() => {
                    reinitializeScriptWithJQuery(scriptSrc);
                    checkForStock();
                }, 250);
            });
        });
    })();
});

function loadScriptWithJQuery(src) {
	return $.Deferred(function (deferred) {
		const script = $('<script>', {
			src: src,
			type: "text/javascript",
			async: true
		}).on('load', function () {
			deferred.resolve(`Script loaded: ${src}`);
		}).on('error', function () {
			deferred.reject(new Error(`Failed to load script: ${src}`));
		});

		$('head').append(script);
	}).promise();
}

function reinitializeScriptWithJQuery(src) {
	const $existingScript = $(`script[src="${src}"]`);
	if ($existingScript.length) {
		$existingScript.remove();
		console.log(`Existing script removed: ${src}`);
	}

	loadScriptWithJQuery(src)
		.done(function (result) {
			console.log(result);
		})
		.fail(function (error) {
			console.error(error.message);
		});
}

function checkForStock() {
    const escBlock = document.querySelector('#esc-oos-form');
    const submitButton = document.querySelectorAll('#c-1635827955167 .gf_add-to-cart')[1];

    if (submitButton.classList.contains('gf_button-soldout') || submitButton.disabled) {
        escBlock.style.display = 'block';
    } else {
        escBlock.style.display = 'none';
    } 
  }
